(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-collage"] && !Shopify.designMode) return;
  try {
    
  // Mobile tap-flip for product cells (desktop uses :hover).
  (function () {
    const init = (root) => {
      if (root.dataset.ccBound) return;
      root.dataset.ccBound = '1';
      root.addEventListener('click', (evt) => {
        if (!matchMedia('(hover: none)').matches) return;
        const cell = evt.target.closest('.cc-cell--product');
        if (!cell) return;
        if (!cell.classList.contains('is-flipped')) {
          evt.preventDefault();
          evt.stopPropagation();
          root.querySelectorAll('.is-flipped').forEach((c) => c !== cell && c.classList.remove('is-flipped'));
          cell.classList.add('is-flipped');
        }
      });
    };
    document.querySelectorAll('[data-collection-collage]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-girl-archetypes"] && !Shopify.designMode) return;
  try {
    
  class ItGirlArchetypes extends HTMLElement {
    connectedCallback() {
      this.activeIndex = 0;
      this.items = Array.from(this.querySelectorAll('[data-ig-item]'));
      this.tabs  = Array.from(this.querySelectorAll('[data-ig-tab]'));
      this.elName     = this.querySelector('[data-ig-active-name]');
      this.elTagline  = this.querySelector('[data-ig-active-tagline]');
      this.elNameEdge = this.querySelector('[data-ig-active-name-edge]');
      this.elNum      = this.querySelector('[data-ig-active-num]');
      this.elVol      = this.querySelector('[data-ig-active-vol]');
      this.elPager    = this.querySelector('[data-ig-pager]');

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.toggle(i));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });
      // Force initial state: ONLY index 0 is open. Otherwise the
      // grid-template-rows: 0fr → 1fr collapse trick can fail under some
      // browsers and leave multiple bodies expanded.
      this.activate(0);
    }

    toggle(index) {
      // On mobile (no hover), tapping the active item collapses it (true accordion).
      // On desktop, tapping always activates (one is always open).
      const isDesktop = matchMedia('(min-width: 990px)').matches;
      if (!isDesktop && index === this.activeIndex) {
        // collapse
        this.items[index]?.classList.remove('is-active');
        this.tabs[index]?.setAttribute('aria-selected', 'false');
        this.tabs[index]?.setAttribute('aria-expanded', 'false');
        this.activeIndex = -1;
        return;
      }
      this.activate(index);
    }

    activate(index) {
      this.activeIndex = index;
      this.items.forEach((it, i) => {
        const active = i === index;
        it.classList.toggle('is-active', active);
        const tab = it.querySelector('[data-ig-tab]');
        if (tab) {
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('aria-expanded', String(active));
        }
      });
      this.updateChrome(index);
    }

    updateChrome(index) {
      const item = this.items[index];
      if (!item) return;
      const total = this.items.length;
      const num = `0${index + 1} / 0${total}`;
      const vols = ['VOL. I', 'VOL. II', 'VOL. III', 'VOL. IV'];
      const vol = vols[index] || `VOL. ${index + 1}`;
      const name = item.querySelector('.ig__h-name')?.textContent.trim() || '';
      const tagline = item.querySelector('.ig__tagline')?.textContent.trim() || '';

      if (this.elName) this.elName.textContent = name;
      if (this.elTagline) this.elTagline.textContent = tagline;
      if (this.elNameEdge) this.elNameEdge.textContent = name;
      if (this.elNum) this.elNum.textContent = num;
      if (this.elVol) this.elVol.textContent = vol;
      if (this.elPager) this.elPager.textContent = `${num} — ${vol}`;
    }

    onKey(evt, i) {
      if (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowDown' && evt.key !== 'ArrowUp') return;
      evt.preventDefault();
      const dir = (evt.key === 'ArrowRight' || evt.key === 'ArrowDown') ? 1 : -1;
      const next = (i + dir + this.tabs.length) % this.tabs.length;
      this.activate(next);
      this.tabs[next]?.focus();
    }
  }
  if (!customElements.get('it-girl-archetypes')) {
    customElements.define('it-girl-archetypes', ItGirlArchetypes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["necklace-builder"] && !Shopify.designMode) return;
  try {
    
  class NecklaceBuilder extends HTMLElement {
    constructor() {
      super();
      this.state = { base: null, charms: [] };
      this.draftBase = null;
      this.draftCharm = null;
      this.activePicker = null;
      this.activeBaseType = 'chain';
      this.catalog = null;
      this.maxCharms = 1;
    }

    connectedCallback() {
      this.currency = this.dataset.currency || 'KWD';
      this.subunits = Number(this.dataset.subunits) || 100;
      this.parentVariantId = this.dataset.parentVariant;
      this.anchorsUrl = this.dataset.anchorsUrl;

      const dataEl = this.querySelector('[data-nb-catalog]');
      try {
        this.catalog = dataEl ? JSON.parse(dataEl.textContent) : { bases: { chain: [], cord: [], stone: [] }, charms: [] };
      } catch (err) {
        console.error('[necklace-builder] catalog parse failed', err);
        this.catalog = { bases: { chain: [], cord: [], stone: [] }, charms: [] };
      }

      // Load anchor data (per-base bottom-center attach + inner_width fit
      // metric; per-charm bbox + loop_y). Re-render once it arrives.
      this.anchors = { bases: {}, charms: {} };
      if (this.anchorsUrl) {
        fetch(this.anchorsUrl)
          .then((r) => r.json())
          .then((data) => {
            this.anchors = data;
            this.render();
          })
          .catch((err) => console.warn('[necklace-builder] anchors load failed', err));
      }

      this.zoneBase = this.querySelector('[data-nb-zone="base"]');
      this.baseImg = this.querySelector('[data-nb-base-img]');
      this.baseTypeEl = this.querySelector('[data-nb-base-type]');
      this.baseTitleEl = this.querySelector('[data-nb-base-title]');
      this.baseSwatchEl = this.querySelector('[data-nb-base-swatch]');
      this.charmsRow = this.querySelector('[data-nb-charms-row]');
      this.overlayRow = this.querySelector('[data-nb-overlay-row]');
      this.priceEl = this.querySelector('[data-nb-price]');
      this.cta = this.querySelector('[data-nb-cta]');

      this.populateCharmTrack();
      this.populateBaseTrack(this.activeBaseType);

      this.querySelectorAll('[data-nb-open]').forEach((btn) =>
        btn.addEventListener('click', this.onOpenPicker.bind(this))
      );
      this.querySelectorAll('[data-nb-close]').forEach((btn) =>
        btn.addEventListener('click', this.onClosePicker.bind(this))
      );
      this.querySelectorAll('[data-nb-confirm]').forEach((btn) =>
        btn.addEventListener('click', this.onConfirm.bind(this))
      );
      this.querySelectorAll('[data-nb-nav]').forEach((btn) =>
        btn.addEventListener('click', this.onNav.bind(this))
      );
      this.querySelectorAll('[data-nb-tab]').forEach((btn) =>
        btn.addEventListener('click', this.onTabClick.bind(this))
      );
      this.querySelectorAll('[data-nb-track]').forEach((track) => {
        track.addEventListener('scroll', () => this.onScroll(track), { passive: true });
        track.addEventListener('click', (e) => this.onTrackClick(e, track));
      });
      this.cta.addEventListener('click', this.onAddToCart.bind(this));
      const sumToggle = this.querySelector('[data-nb-summary-toggle]');
      const sumZone = this.querySelector('[data-nb-summary]');
      if (sumToggle && sumZone) {
        sumToggle.addEventListener('click', () => {
          const expanded = sumZone.dataset.expanded === 'true';
          sumZone.dataset.expanded = expanded ? 'false' : 'true';
          sumToggle.setAttribute('aria-expanded', String(!expanded));
        });
      }
      document.addEventListener('keydown', this.onKeyDown.bind(this));

      this.render();
    }

    populateBaseTrack(baseType) {
      const modal = this.querySelector('[data-nb-modal="base"]');
      if (!modal) return;
      const track = modal.querySelector('[data-nb-track]');
      const items = (this.catalog.bases && this.catalog.bases[baseType]) || [];
      track.innerHTML = items.map((item) => this.renderBaseCard(item, baseType)).join('');
      track.scrollLeft = 0;
      requestAnimationFrame(() => this.onScroll(track));
    }

    populateCharmTrack() {
      const modal = this.querySelector('[data-nb-modal="charm"]');
      if (!modal) return;
      const track = modal.querySelector('[data-nb-track]');
      track.innerHTML = (this.catalog.charms || []).map((c) => this.renderCharmCard(c)).join('');
      requestAnimationFrame(() => this.onScroll(track));
    }

    renderBaseCard(item, baseType) {
      const swatches = (item.swatches || []).map((s, i) => {
        const styleParts = [`--swatch-image: url('${this.escUrl(s.image)}')`];
        if (s.color) styleParts.push(`--swatch-color: ${this.escAttr(s.color)}`);
        return `<button type="button" class="nb-swatch${i === 0 ? ' is-active' : ''}${s.color ? ' nb-swatch--color' : ''}" data-nb-swatch="${this.escAttr(s.label)}" data-swatch-image="${this.escAttr(s.image)}"${s.color ? ` data-swatch-color="${this.escAttr(s.color)}"` : ''} style="${styleParts.join('; ')};" aria-label="${this.escAttr(s.label)}"></button>`;
      }).join('');
      const swatchesBlock = swatches ? `<div class="nb-card__swatches">${swatches}</div>` : '';
      const initialImg = (item.swatches && item.swatches.length) ? item.swatches[0].image : item.image;
      const initialSwatch = (item.swatches && item.swatches.length) ? item.swatches[0].label : '';
      return `
        <article class="nb-card" data-nb-card data-id="${this.escAttr(item.id)}" data-base-type="${baseType}" data-price="${item.price}" data-title="${this.escAttr(item.title)}" data-image="${this.escAttr(initialImg)}" data-price-display="${this.escAttr(this.formatMoney(item.price))}" data-swatch="${this.escAttr(initialSwatch)}">
          <div class="nb-card__media"><img src="${this.escUrl(initialImg)}" alt="${this.escAttr(item.title)}" loading="lazy"></div>
          ${swatchesBlock}
        </article>`;
    }

    renderCharmCard(item) {
      return `
        <article class="nb-card" data-nb-card data-id="${this.escAttr(item.id)}" data-price="${item.price}" data-title="${this.escAttr(item.title)}" data-image="${this.escAttr(item.image)}" data-price-display="${this.escAttr(this.formatMoney(item.price))}">
          <div class="nb-card__media"><img src="${this.escUrl(item.image)}" alt="${this.escAttr(item.title)}" loading="lazy"></div>
        </article>`;
    }

    escAttr(v) {
      return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }
    escUrl(v) {
      const s = String(v || '');
      if (/^javascript:/i.test(s)) return '';
      return s.replace(/"/g, '&quot;');
    }

    onOpenPicker(evt) {
      const key = evt.currentTarget.dataset.nbOpen;
      const modal = this.querySelector(`[data-nb-modal="${key}"]`);
      if (!modal) return;
      // Note: don't block re-opening the charm picker when one is already
      // chosen — that's the "Change charm" flow. The picker itself replaces
      // the existing charm on confirm.

      this.activePicker = key;
      this.draftBase = null;
      this.draftCharm = null;

      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.body.style.overflow = 'hidden';

      if (key === 'base') {
        const startType = this.state.base?.type || this.activeBaseType;
        this.activateTab(startType, { scrollToCurrent: true });
      } else if (key === 'charm') {
        // Pre-scroll to the currently-selected charm if any
        const current = this.state.charms[0];
        if (current) {
          const charmTrack = modal.querySelector('[data-nb-track]');
          const card = charmTrack?.querySelector(`[data-id="${current.id}"]`);
          if (card && charmTrack) {
            requestAnimationFrame(() => {
              charmTrack.scrollLeft = card.offsetLeft - (charmTrack.clientWidth / 2) + (card.clientWidth / 2);
              this.onScroll(charmTrack);
            });
          }
        }
      }

      const track = modal.querySelector('[data-nb-track]');
      if (track) requestAnimationFrame(() => this.onScroll(track));
    }

    onClosePicker(evt) {
      const key = evt?.currentTarget?.dataset?.nbClose || this.activePicker;
      if (!key) return;
      const modal = this.querySelector(`[data-nb-modal="${key}"]`);
      if (!modal) return;
      modal.classList.remove('is-open');
      setTimeout(() => { modal.hidden = true; }, 300);
      this.activePicker = null;
      this.draftBase = null;
      this.draftCharm = null;
      document.body.style.overflow = '';
    }

    onConfirm(evt) {
      const key = evt.currentTarget.dataset.nbConfirm;
      if (key === 'base') {
        if (!this.draftBase) return;
        this.state.base = this.draftBase;
      } else if (key === 'charm') {
        if (!this.draftCharm) return;
        // Single-charm builder: confirming a charm always replaces the
        // current selection rather than appending.
        this.state.charms = [this.draftCharm];
      }
      this.render();
      this.onClosePicker();
    }

    removeCharm(id) {
      this.state.charms = this.state.charms.filter((c) => c.id !== id);
      this.render();
    }

    onTabClick(evt) { this.activateTab(evt.currentTarget.dataset.nbTab); }

    activateTab(type, { scrollToCurrent = false } = {}) {
      this.activeBaseType = type;
      const modal = this.querySelector('[data-nb-modal="base"]');
      modal.querySelectorAll('[data-nb-tab]').forEach((btn) => {
        const isActive = btn.dataset.nbTab === type;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', String(isActive));
      });
      this.populateBaseTrack(type);

      if (scrollToCurrent && this.state.base && this.state.base.type === type) {
        const track = modal.querySelector('[data-nb-track]');
        const card = track.querySelector(`[data-id="${this.state.base.item.id}"]`);
        if (card) {
          requestAnimationFrame(() => {
            track.scrollLeft = card.offsetLeft - (track.clientWidth / 2) + (card.clientWidth / 2);
            this.onScroll(track);
          });
        }
      }
    }

    onNav(evt) {
      const dir = evt.currentTarget.dataset.nbNav;
      const modal = evt.currentTarget.closest('[data-nb-modal]');
      const track = modal?.querySelector('[data-nb-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('[data-nb-card]'));
      const activeIndex = cards.findIndex((c) => c.classList.contains('is-active'));
      const next = dir === 'next' ? Math.min(cards.length - 1, activeIndex + 1) : Math.max(0, activeIndex - 1);
      const target = cards[next];
      if (!target) return;
      track.scrollTo({
        left: target.offsetLeft - (track.clientWidth / 2) + (target.clientWidth / 2),
        behavior: 'smooth',
      });
    }

    onTrackClick(evt, track) {
      const swatch = evt.target.closest('[data-nb-swatch]');
      if (swatch) { evt.stopPropagation(); this.onSwatchPick(swatch); return; }
      const card = evt.target.closest('[data-nb-card]');
      if (!card || card.classList.contains('is-active')) return;
      track.scrollTo({
        left: card.offsetLeft - (track.clientWidth / 2) + (card.clientWidth / 2),
        behavior: 'smooth',
      });
    }

    onSwatchPick(swatch) {
      const card = swatch.closest('[data-nb-card]');
      if (!card) return;
      card.querySelectorAll('[data-nb-swatch]').forEach((s) => s.classList.toggle('is-active', s === swatch));
      const newImage = swatch.dataset.swatchImage;
      const newLabel = swatch.dataset.nbSwatch;
      const img = card.querySelector('img');
      if (img) img.src = newImage;
      card.dataset.image = newImage;
      card.dataset.swatch = newLabel;
      if (card.classList.contains('is-active')) this.draftBase = this.readBaseCard(card);
    }

    onScroll(track) {
      const trackRect = track.getBoundingClientRect();
      const centerX = trackRect.left + trackRect.width / 2;
      const cards = Array.from(track.querySelectorAll('[data-nb-card]'));
      let closest = null;
      let closestDist = Infinity;
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const dist = Math.abs(cardCenter - centerX);
        card.classList.toggle('is-active', false);
        if (dist < closestDist) { closestDist = dist; closest = card; }
      });
      if (closest) {
        closest.classList.add('is-active');
        const modal = track.closest('[data-nb-modal]');
        const isBase = modal?.dataset.nbModal === 'base';
        if (isBase) this.draftBase = this.readBaseCard(closest);
        else this.draftCharm = this.readCharmCard(closest);
        this.updateModalMeta(track, closest);
      }
      const modal = track.closest('[data-nb-modal]');
      if (modal) {
        const prevBtn = modal.querySelector('[data-nb-nav="prev"]');
        const nextBtn = modal.querySelector('[data-nb-nav="next"]');
        const activeIdx = cards.indexOf(closest);
        if (prevBtn) prevBtn.disabled = activeIdx <= 0;
        if (nextBtn) nextBtn.disabled = activeIdx >= cards.length - 1;
      }
    }

    updateModalMeta(track, card) {
      const modal = track.closest('[data-nb-modal]');
      if (!modal) return;
      const titleEl = modal.querySelector('[data-nb-modal-title]');
      const priceEl = modal.querySelector('[data-nb-modal-price]');
      if (titleEl) titleEl.textContent = card.dataset.title || '';
      if (priceEl) priceEl.textContent = card.dataset.priceDisplay || '';
    }

    readBaseCard(card) {
      return {
        type: card.dataset.baseType,
        item: {
          id: card.dataset.id,
          title: card.dataset.title || '',
          price: Number(card.dataset.price || 0),
          image: card.dataset.image || '',
        },
        swatch: card.dataset.swatch || '',
      };
    }
    readCharmCard(card) {
      return {
        id: card.dataset.id,
        price: Number(card.dataset.price || 0),
        title: card.dataset.title || '',
        image: card.dataset.image || '',
      };
    }

    onKeyDown(evt) {
      if (!this.activePicker) return;
      if (evt.key === 'Escape') { this.onClosePicker(); }
      else if (evt.key === 'ArrowLeft' || evt.key === 'ArrowRight') {
        const dir = evt.key === 'ArrowRight' ? 'next' : 'prev';
        const btn = this.querySelector(`[data-nb-modal="${this.activePicker}"] [data-nb-nav="${dir}"]`);
        if (btn) btn.click();
      }
    }

    /* ===== Render tray ===== */
    render() {
      // BASE zone
      const base = this.state.base;
      this.zoneBase.dataset.state = base ? 'filled' : 'empty';
      if (base) {
        if (this.baseImg.src !== base.item.image) this.baseImg.src = base.item.image;
        this.baseImg.alt = base.item.title || '';
        this.baseImg.hidden = false;
        this.baseTypeEl.textContent = this.capitalize(base.type);
        this.baseTitleEl.textContent = base.item.title;
        if (base.swatch) {
          this.baseSwatchEl.textContent = base.swatch;
          this.baseSwatchEl.hidden = false;
        } else {
          this.baseSwatchEl.hidden = true;
          this.baseSwatchEl.textContent = '';
        }
      } else {
        this.baseImg.hidden = true;
        this.baseImg.removeAttribute('src');
        this.baseTypeEl.textContent = '—';
        this.baseTitleEl.textContent = 'Untitled';
        this.baseSwatchEl.hidden = true;
        this.baseSwatchEl.textContent = '';
      }

      // CHARM zone — single chip with edit/remove. Replaces the chip in
      // place rather than diff/append since there's at most one.
      const charm = this.state.charms[0] || null;
      const zoneCharms = this.querySelector('[data-nb-zone="charms"]');
      const charmCta = this.querySelector('[data-nb-charm-cta]');
      const charmCtaLabel = this.querySelector('[data-nb-charm-cta-label]');
      this.charmsRow.innerHTML = '';
      if (charm) {
        if (zoneCharms) zoneCharms.dataset.state = 'filled';
        if (charmCtaLabel) charmCtaLabel.textContent = 'Change charm';
        const li = document.createElement('li');
        li.className = 'nb__charm-chip';
        li.dataset.charmId = charm.id;
        li.title = charm.title;
        li.innerHTML = `
          <img src="${this.escUrl(charm.image)}" alt="${this.escAttr(charm.title)}">
          <button type="button" class="nb__charm-chip-remove" aria-label="Remove ${this.escAttr(charm.title)}">×</button>
        `;
        li.querySelector('.nb__charm-chip-remove').addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeCharm(charm.id);
        });
        this.charmsRow.appendChild(li);
      } else {
        if (zoneCharms) zoneCharms.dataset.state = 'empty';
        if (charmCtaLabel) charmCtaLabel.textContent = 'Add charm';
      }

      // Composite overlay: the single charm hangs from the bottom-center
      // of the chain, sized so the pendant fits inside the chain's gap.
      if (this.overlayRow) {
        this.overlayRow.innerHTML = '';
        if (base && charm) {
          const baseKey = this.imageKey(base.item.image);
          const anchor = this.anchors.bases && this.anchors.bases[baseKey];
          const charmKey = this.imageKey(charm.image);
          const charmData = this.anchors.charms && this.anchors.charms[charmKey];

          if (anchor && charmData) {
            // Compute a target charm canvas width (as % of the base frame)
            // such that the charm's actual pendant body (bbox_w_frac of the
            // canvas) ends up ~1.4× the chain inner_width — i.e. the pendant
            // visibly hangs across and just past the chain ends.
            const fitFactor = 1.4;
            const bboxW = Math.max(0.05, charmData.bbox_w_frac || 0.5);
            const charmCanvasWPct = Math.min(72, (anchor.inner_width || 25) * fitFactor / bboxW);
            const aspect = (charmData.width && charmData.height)
              ? charmData.width / charmData.height
              : 1;
            // Inline-positioned overlay: anchor at attach_x/attach_y, then
            // translate(-bbox_cx*100%, -loop_y*100%) so the visible bbox top
            // sits at the chain's bottom-center attach point.
            const span = document.createElement('span');
            span.className = 'nb__overlay-charm';
            span.dataset.overlayId = charm.id;
            span.style.setProperty('--charm-image', `url('${this.escUrl(charm.image)}')`);
            span.style.setProperty('--charm-w', charmCanvasWPct + '%');
            span.style.setProperty('--charm-aspect', String(aspect));
            span.style.setProperty('--anchor-x', (anchor.attach_x || 50) + '%');
            span.style.setProperty('--anchor-y', (anchor.attach_y || 90) + '%');
            span.style.setProperty('--bbox-cx', String(charmData.bbox_cx || 0.5));
            // Precompute the vertical translate as one percentage so the
            // CSS doesn't have to multiply two unitless custom properties
            // inside calc() (some browsers/Shopify CDN environments collapse
            // that to 0%).
            const liftRaw = getComputedStyle(this).getPropertyValue('--nb-charm-lift') || '2.5';
            const lift = parseFloat(liftRaw) || 2.5;
            const bboxH = charmData.bbox_h_frac || 0.2;
            const loopY = charmData.loop_y || 0;
            const translateYPct = -(loopY * 100 + lift * bboxH * 100);
            span.style.setProperty('--nb-translate-y', translateYPct.toFixed(2) + '%');
            this.overlayRow.appendChild(span);
          }
        }
      }

      // SUMMARY
      const baseLabelEl = this.querySelector('[data-nb-breakdown-base-label]');
      const baseValueEl = this.querySelector('[data-nb-breakdown-base]');
      if (baseLabelEl) baseLabelEl.textContent = base ? this.capitalize(base.type) : 'Base';
      if (baseValueEl) baseValueEl.textContent = base ? this.formatMoney(base.item.price) : '—';
      const charmsValueEl = this.querySelector('[data-nb-breakdown-charms]');
      if (charmsValueEl) {
        const charmsTotal = this.state.charms.reduce((s, c) => s + c.price, 0);
        charmsValueEl.textContent = charmsTotal ? this.formatMoney(charmsTotal) : '—';
      }
      const total = this.calcTotal();
      const display = total > 0 ? this.formatMoney(total) : '—';
      if (this.priceEl.textContent !== display) {
        this.priceEl.textContent = display;
        this.priceEl.classList.remove('is-flash');
        void this.priceEl.offsetWidth;
        this.priceEl.classList.add('is-flash');
      }
      this.cta.disabled = !this.state.base;
    }

    capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

    /** Strip query/path/extension to get the asset basename key (e.g. "nb-img-chain-paperclip"). */
    imageKey(url) {
      try {
        const u = String(url || '').split('?')[0];
        const file = u.split('/').pop() || '';
        return file.replace(/\.(png|jpe?g|webp)$/i, '');
      } catch (_e) { return ''; }
    }
    calcTotal() {
      let t = 0;
      if (this.state.base) t += this.state.base.item.price;
      t += this.state.charms.reduce((s, c) => s + c.price, 0);
      return t;
    }
    formatMoney(value) {
      const amount = value / this.subunits;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: this.subunits === 1000 ? 3 : (this.subunits === 1 ? 0 : 2),
          maximumFractionDigits: this.subunits === 1000 ? 3 : (this.subunits === 1 ? 0 : 2),
        }).format(amount);
      } catch (_e) {
        return `${amount.toFixed(this.subunits === 1000 ? 3 : 2)} ${this.currency}`;
      }
    }

    async onAddToCart() {
      if (!this.state.base) {
        this.cta.textContent = 'Pick a base first';
        return;
      }
      const base = this.state.base;
      // The card dataset only carries id/title/price/image, so look up the
      // full record from the catalog to recover the variant_id (and swatches
      // for multi-colour bases).
      const fullBase = (this.catalog?.bases?.[base.type] || []).find((b) => b.id === base.item.id);
      const baseVariantId = !fullBase
        ? null
        : (base.swatch
            ? (fullBase.swatches || []).find((s) => s.label === base.swatch)?.variant_id
            : fullBase.variant_id);
      if (!baseVariantId) {
        this.cta.textContent = 'Not configured';
        console.warn('[necklace-builder] missing variant_id for base', base, fullBase);
        return;
      }
      // Group identifier so the cart drawer / future template can visually
      // bundle the lines that came from one builder click.
      const kitId = 'k-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      const charmEntries = this.state.charms
        .map((c) => {
          const full = (this.catalog?.charms || []).find((x) => x.id === c.id);
          return full?.variant_id ? { variant_id: full.variant_id, title: c.title } : null;
        })
        .filter(Boolean);
      const items = [
        {
          id: Number(baseVariantId),
          quantity: 1,
          properties: {
            _Kit_ID: kitId,
            _Kit_Role: 'Base',
            _Kit_Type: base.type,
            ...(base.swatch ? { _Kit_Color: base.swatch } : {}),
          },
        },
        ...charmEntries.map((c) => ({
          id: Number(c.variant_id),
          quantity: 1,
          properties: { _Kit_ID: kitId, _Kit_Role: 'Charm' },
        })),
      ];
      try {
        this.cta.disabled = true;
        this.cta.textContent = 'Adding…';
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error(await res.text());
        this.cta.textContent = 'Added ✓';
        try {
          const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = cartRes.ok ? await cartRes.json() : null;
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'necklace-builder', data: { source: 'necklace-builder', itemCount: cart?.item_count } },
          }));
        } catch (_e) { /* drawer refresh is best-effort */ }
      } catch (err) {
        console.error('[necklace-builder] cart add failed', err);
        this.cta.textContent = 'Try again';
        this.cta.disabled = false;
      }
    }
  }

  if (!customElements.get('necklace-builder')) {
    customElements.define('necklace-builder', NecklaceBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunstone-hero"] && !Shopify.designMode) return;
  try {
    
  class SunstoneHero extends HTMLElement {
    constructor() {
      super();
      this.lastY = 0;
      this.rot = 0;
      this.ticking = false;
      this.inView = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      if (this.reducedMotion) return;
      this.stages = Array.from(this.querySelectorAll('[data-sh-stage]')).map((stage) => ({
        stage,
        baseImg: stage.querySelector('[data-sh-base]'),
        charms: Array.from(stage.querySelectorAll('[data-sh-charm]')),
        postcard: stage.querySelector('[data-sh-postcard]'),
      }));
      // For viewport / scroll math we use whichever stage is currently visible.
      this.stage = this.stages[0]?.stage;
      if (!this.stage) return;

      this.lastY = window.scrollY;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      // Stop animating once the hero is fully off-screen.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          for (const e of entries) this.inView = e.isIntersecting;
        }, { threshold: 0 });
        this.io.observe(this);
      }

      // Prime the transform once on mount.
      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.io) this.io.disconnect();
    }

    onScroll() {
      if (!this.inView || this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => this.update());
    }

    update() {
      this.ticking = false;
      const y = window.scrollY;
      const dy = y - this.lastY;
      this.lastY = y;
      this.rot += dy * 1.2;

      for (const { stage, baseImg, charms, postcard } of this.stages) {
        // Skip stages that are hidden via CSS — saves work and avoids
        // animating elements the user can't see.
        if (stage.offsetParent === null) continue;
        if (!baseImg) continue;

        const stageRect = stage.getBoundingClientRect();
        const stageH = stageRect.height || window.innerHeight;
        const scrollFrac = Math.max(0, Math.min(1, -stageRect.top / stageH));

        const py = -scrollFrac * 180;
        const ps = 1.05 + scrollFrac * 0.18;
        const tilt = scrollFrac * -6;
        baseImg.style.setProperty('--sh-py', py.toFixed(2) + 'px');
        baseImg.style.setProperty('--sh-ps', ps.toFixed(3));
        baseImg.style.setProperty('--sh-tilt', tilt.toFixed(2) + 'deg');

        const pushZ = scrollFrac * 120;
        for (const charm of charms) {
          const sign = Number(charm.dataset.shDir) || 1;
          const phase = Number(charm.dataset.shPhase) || 0;
          const localBob = Math.sin((scrollFrac + phase) * Math.PI * 2) * 28;
          const allowRot = charm.dataset.shRotate !== 'false';
          charm.style.setProperty('--sh-rot', allowRot ? (this.rot * sign).toFixed(2) + 'deg' : '0deg');
          charm.style.setProperty('--sh-by', localBob.toFixed(2) + 'px');
          charm.style.setProperty('--sh-bz', pushZ.toFixed(2) + 'px');
        }

        if (postcard) {
          const pcRotMax = Number(postcard.dataset.shRotMax || 6);
          const pcRot = (scrollFrac - 0.5) * 2 * pcRotMax;
          const pcY   = -scrollFrac * 90;
          postcard.style.setProperty('--sh-pc-rot', pcRot.toFixed(2) + 'deg');
          postcard.style.setProperty('--sh-pc-py',  pcY.toFixed(2) + 'px');
        }
      }
    }
  }

  if (!customElements.get('sunstone-hero')) {
    customElements.define('sunstone-hero', SunstoneHero);
  }

  } catch(e) { console.error(e); }
})();
})();
